import Products from "../components/Products"

export default function Index() {
    return (
        <div>
            <h4>All Products</h4>
            <Products />
        </div>
    )
}